/**
 * Tell the app's native crash reporter who is signed in (2026-10-23).
 *
 * The native shell now starts its own Sentry on launch (ios/App/App/AppDelegate.swift,
 * android/.../MainActivity.java), before this website has loaded, so a crash that early cannot
 * ask the page who the member is. The page writes the member's id into the phone's native storage
 * instead, and the native reporter reads it back when it sends a report. Only the id, never the
 * email. Key name is read natively: renaming it means renaming it there too.
 *
 * Best-effort and silent: on the website, or on an older app binary, it simply does nothing.
 */
const USER_KEY = "sentry_user_id";

export function rememberNativeCrashUser(userId: string | null): void {
  void (async () => {
    const { Capacitor } = await import("@capacitor/core");
    if (!Capacitor.isNativePlatform()) return;
    const { Preferences } = await import("@capacitor/preferences");
    // Never `return Preferences` from an async function: the Promise would call `.then` on the
    // plugin proxy, which the native side rejects ("Preferences.then() is not implemented").
    if (userId) await Preferences.set({ key: USER_KEY, value: userId });
    else await Preferences.remove({ key: USER_KEY });
  })().catch(() => {
    /* storage unavailable: the crash report just lacks a member id */
  });
}
